import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({ dispatch }, payload) => {
    return serves.trabalhadorcontrato.cadastra(payload).then(res => {
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionLista = ({ dispatch }, payload) => {
    return serves.trabalhadorcontrato.lista(payload).then(res => {
        dispatch('ActionSetLista', res)
    }).catch(err => {
        dispatch('ActionSetLista', res)
    })
}
export const ActionPesquisa = ({ dispatch }, payload) => {
    return serves.trabalhadorlotacao.pesquisa(payload).then(res => {
        dispatch('ActionSetCategorias', res)
    }).catch(err => {
        dispatch('ActionSetCategorias', res)
    })
}
export const ActionDeletar = ({ dispatch }, payload) => {
    return serves.trabalhadorcontrato.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionEditar = ({ dispatch }, payload) => {
    return serves.trabalhadorcontrato.editar(payload).then(res => {
        dispatch('ActionSetEditar', res)
    }).catch(err => {
        dispatch('ActionSetEditar', err)
    })
}
export const ActionEventoShow = ({ dispatch }, payload) => {
    return serves.trabalhadorcontrato.showevento(payload).then(res => {
        dispatch('ActionSetEvento', res)
    }).catch(err => {
        dispatch('ActionSetEvento', err)
    })
}
export const ActionUpdate = ({ dispatch }, payload) => {
    return serves.trabalhadorcontrato.update(payload).then(res => {
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionUpdateEvento2206 = ({ dispatch }, payload) => {
    if (payload.evento === '2206') {
        return serves.trabalhadorcontrato.update2206(payload).then(res => {
            dispatch('ActionSetMsg', res)
        }).catch(err => {
            dispatch('ActionSetMsg', err)
        })
    } else {
        return serves.trabalhadorcontrato.update2306(payload).then(res => {
            dispatch('ActionSetMsg', res)
        }).catch(err => {
            dispatch('ActionSetMsg', err)
        })
    }
}
export const ActionDeleteEvento2206 = ({ dispatch }, payload) => {
    if (payload.evento === '2206') {
        return serves.trabalhadorcontrato.delete2206(payload).then(res => {
            dispatch('ActionSetMsg', res)
        }).catch(err => {
            dispatch('ActionSetMsg', err)
        })
    } else {
        return serves.trabalhadorcontrato.delete2306(payload).then(res => {
            dispatch('ActionSetMsg', res)
        }).catch(err => {
            dispatch('ActionSetMsg', err)
        })
    }
}
export const ActionCadastroEvento2206 = ({ dispatch }, payload) => {
    if (payload.evento == '2206') {
        return serves.trabalhadorcontrato.cadastra2206(payload).then(res => {
            dispatch('ActionSetMsg', res)
        }).catch(err => {
            dispatch('ActionSetMsg', err)
        })
    } else {
        return serves.trabalhadorcontrato.cadastra2306(payload).then(res => {
            dispatch('ActionSetMsg', res)
        }).catch(err => {
            dispatch('ActionSetMsg', err)
        })
    }
}
export const ActionPerfil = ({ dispatch }, payload) => {
    return serves.trabalhadorcontrato.show(payload).then(res => {
        dispatch('ActionSetPerfil', res)
    }).catch(err => {
        dispatch('ActionSetPerfil', err)
    })
}
export const ActionSetLista = ({ commit }, payload) => {
    commit(types.SET_LISTA, payload)
}
export const ActionSetMsg = ({ commit }, payload) => {
    commit(types.SET_MSG, payload)
}
export const ActionSetEditar = ({ commit }, payload) => {
    commit(types.SET_EDITAR, payload)
}
export const ActionSetCategorias = ({ commit }, payload) => {
    commit(types.SET_CATEGORIAS, payload)
}
export const ActionSetPerfil = ({ commit }, payload) => {
    commit(types.SET_PERFIL, payload)
}
export const ActionSetEvento = ({ commit }, payload) => {
    commit(types.SET_EVENTO, payload)
}
